var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-container"},_vm._l((_vm.groups),function(group,idx){return _c('div',{key:idx,staticClass:"tag",class:_vm.getTagClass(group)},[_vm._v(" "+_vm._s(_vm._f("titlecase")(_vm._f("whitespace")(group)))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }